import { useNavigate } from 'react-router-dom';

/**
 * The circled "i" next to a term that has an explanation.
 *
 * Opens a full page rather than a dialog, matching how the rest of the app
 * works — and a full page is where a few paragraphs of reading actually belong
 * on a phone. `returnTo` brings you straight back to where you tapped it.
 */
export default function InfoButton({ techniqueId, label }: { techniqueId: string; label: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="info-btn"
      aria-label={`What is ${label}?`}
      onClick={() =>
        navigate(`/technique/${techniqueId}`, {
          state: { returnTo: window.location.pathname },
        })
      }
    >
      i
    </button>
  );
}
